import { Controller } from "@hotwired/stimulus"

// Copies the source target's value to the clipboard and flashes the button
// label as confirmation.
export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(this.sourceTarget.value)
      } else {
        this.sourceTarget.select()
        this.sourceTarget.setSelectionRange(0, this.sourceTarget.value.length)
        document.execCommand("copy")
      }

      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = "Copied!"
      setTimeout(() => {
        this.buttonTarget.textContent = original
      }, 1500)
    } catch (error) {
      console.error("Unable to copy to clipboard", error)
    }
  }
}
